import { render, staticRenderFns } from "./model-form.vue?vue&type=template&id=e797c13e&scoped=true&"
import script from "./model-form.vue?vue&type=script&lang=ts&"
export * from "./model-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e797c13e",
  null
  
)

export default component.exports